import React from "react";
import { Link } from "react-router-dom";

export function Logo({ to = "/", size = "md", inverse = false }) {
  const heights = {
    sm: "h-7",
    md: "h-10",
    lg: "h-12",
    xl: "h-16 sm:h-20",
  };
  const src = inverse ? "/logo-getickets-inverse.png" : "/logo-getickets.png";
  return (
    <Link to={to} data-testid="logo-link" className="inline-flex items-center">
      <img
        src={src}
        alt="Getickets — Australian event ticketing"
        className={`${heights[size]} w-auto`}
        draggable="false"
      />
    </Link>
  );
}
